import { FunctionComponent, useEffect, useState } from "react";
import useDevice from "../../utils/hooks/useDevice";
import HomeCatalogDesktop from "../HomeCatalogDesktop";
import HomeCatalogMobile from "../HomeCatalogMobile";

type Props = {
  sections: CarouselExtended[];
};

const HomeCatalogContainer: FunctionComponent<Props> = ({ sections }) => {
  const { width } = useDevice();
  const [chain, setChain] = useState<CarouselExtended>();
  const [brazalete, setBrazalete] = useState<CarouselExtended>();
  const [pendant, setPendant] = useState<CarouselExtended>();
  const [ring, setRing] = useState<CarouselExtended>();
  const [hoop, setHoop] = useState<CarouselExtended>();
  const [finding, setfinding] = useState<CarouselExtended>();

  useEffect(() => {
    setChain(sections.find((el) => el.name == "CHAIN"));
    setBrazalete(sections.find((el) => el.name == "BRAZALETE"));
    setPendant(sections.find((el) => el.name == "PENDANT"));
    setRing(sections.find((el) => el.name == "RING"));
    setHoop(sections.find((el) => el.name == "HOOP"));
    setfinding(sections.find((el) => el.name == "finding"));
  }, []);

  return (
    <>
      {width > 900 ? (
        <>
          <header className="home_catalog_container_header">
            <h3>Conocé nuestros productos</h3>
          </header>
          {chain && <HomeCatalogDesktop sections={chain} />}
          {brazalete && <HomeCatalogDesktop sections={brazalete} />}
          {pendant && <HomeCatalogDesktop sections={pendant} />}
          {ring && <HomeCatalogDesktop sections={ring} />}
          {hoop && <HomeCatalogDesktop sections={hoop} />}
          {finding && <HomeCatalogDesktop sections={finding} />}
        </>
      ) : (
        <>
          <header className="home_catalog_container_header">
            <h3>Conocé todos los productos</h3>
          </header>
          {chain && <HomeCatalogMobile sections={chain} />}
          {brazalete && <HomeCatalogMobile sections={brazalete} />}
          {pendant && <HomeCatalogMobile sections={pendant} />}
          {ring && <HomeCatalogMobile sections={ring} />}
          {hoop && <HomeCatalogDesktop sections={hoop} />}
          {finding && <HomeCatalogDesktop sections={finding} />}
        </>
      )}
    </>
  );
};

export default HomeCatalogContainer;
